/******************************* 系统-教师工账号 *******************************/
import request from "@/utils/request";

// 教师管理端-教师信息
// export function userInfo() {
//   return request({
//     url: `/upms/teacher/info`,
//     method: "post",
//   });
// }

export function userInfo() {
  return request({
    url: `/auth/info`,
    method: "post",
  });
}

// 获取验证码
export function captcha(data) {
  return request({
    url: `/auth/captcha`,
    method: "post",
    data,
  });
}

// 教师管理端-登录（含验证码）
export function login(data) {
  return request({
    url: `/auth/login`,
    method: "post",
    data,
  });
}

export function loginTz(data) {
  return request({
    url: `/upms/account/user/tz/login`,
    method: "post",
    data,
  });
}

// 教师管理端-退出
export function logout(data) {
  return request({
    url: "/auth/logout",
    method: "post",
    data,
  });
}

export function siteInfo(data) {
  return request({
    url: '/upms/site/info/ywtb',
    method: 'post',
    data,
  });
}

// 教师管理端-修改密码
export function editTeaPwd(data) {
  return request({
    url: '/auth/change/pwd',
    method: 'post',
    data,
  });
}
